/** Mirrors role slugs seeded by database/seeders/RoleSeeder.php. */
export const ROLES = {
  ADMIN: 'admin',
  OWNER: 'owner',
  RECEPTION_STAFF: 'reception-staff',
  SERVICE_STAFF: 'service-staff',
  USER: 'user',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

/**
 * Every role except Admin — Admin is restricted to the dashboard and client
 * (customer) management only, while these roles retain full access to the
 * rest of the application's operational modules.
 */
export const STAFF_ROLES = [ROLES.OWNER, ROLES.RECEPTION_STAFF, ROLES.SERVICE_STAFF, ROLES.USER];
